import React, { useState } from 'react';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { catchError } from '../../../core/catch-error';
import { OptionCardGroup } from '../../../components/option-card-group/option-card-group';
import { ASSIGNABLE_ROLE_OPTIONS } from '../constants/roles';
import { toastPool } from '../../toasts/models/toast-pool';
import { Toast } from '../../toasts/models/toast';
import styles from './change-role.modal.module.scss';

import type { Member } from '../../../app/entities';

type ChangeRoleModalProps = {
  member: Member;
  onCancel: () => void;
};

export const ChangeRoleModal: React.FC<ChangeRoleModalProps> = ({ member, onCancel }) => {
  const currentRole = member.role?.toLowerCase() ?? '';
  const [selectedRole, setSelectedRole] = useState(currentRole);
  const [isLoading, setIsLoading] = useState(false);

  const hasChanged = selectedRole !== currentRole;

  const handleSave = async () => {
    if (isLoading || !hasChanged) return;

    setIsLoading(true);

    try {
      await member.update({ role: selectedRole });
      toastPool.insert(new Toast('Role updated'));
      onCancel();
    } catch (error) {
      catchError(error);
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      title={`Change ${member.fullName}'s role`}
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} disabled={isLoading} />,
        <ElevatedButton
          key="save"
          text="Save"
          onClick={handleSave}
          disabled={!hasChanged}
          isLoading={isLoading}
          autoFocus
        />,
      ]}
    >
      <div className={styles.container}>
        <OptionCardGroup
          aria-label="Role"
          options={ASSIGNABLE_ROLE_OPTIONS}
          value={selectedRole}
          onChange={setSelectedRole}
        />
      </div>
    </Dialog>
  );
};
